import * as firebase from "firebase/app";
import "firebase/auth";

/**
 * Returns a promise that resolves with an ID token if available.
 * @return {!Promise<?string>} The promise that resolves with an ID token if
 *     available. Otherwise, the promise resolves with null.
 */
const getIdToken = () => {
  return new Promise((resolve, reject) => {
    // Add timeout to prevent hanging indefinitely
    const timeout = setTimeout(() => {
      console.warn('Firebase auth timeout - continuing without token');
      resolve(null);
    }, 5000);
    
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      clearTimeout(timeout);
      unsubscribe();
      if (user) {
        user.getIdToken().then((idToken) => {
          resolve(idToken);
        }, (error) => {
          console.error('Firebase token error:', error);
          resolve(null);
        });
      } else {
        resolve(null);
      }
    });
  });
};

const getFirebaseUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      unsubscribe();
      resolve(user);
    });
  });
};

export { getIdToken, getFirebaseUser }